'use client';

import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import CMSRouteParamsContext from './CMSRouteParamsContext';
import getCmsParams from './getCmsParams';
const CMSRouteParamsProvider = t0 => {
  const $ = _c(6);
  const {
    children,
    path,
    routeKey
  } = t0;
  let t1;
  if ($[0] !== path || $[1] !== routeKey) {
    t1 = getCmsParams(path, routeKey);
    $[0] = path;
    $[1] = routeKey;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const cmsParams = t1;
  let t2;
  if ($[3] !== children || $[4] !== cmsParams) {
    t2 = <CMSRouteParamsContext.Provider value={cmsParams}>{children}</CMSRouteParamsContext.Provider>;
    $[3] = children;
    $[4] = cmsParams;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export default CMSRouteParamsProvider;